<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h3 class="text-primary text-center mt-0">
      Listado de facturas
    </h3>

    <v-btn rounded small @click="openUpiMomentaneoFact()" v-if="vermomentaneo()">
      <v-icon color="blue">mdi-information</v-icon>
    </v-btn>

    <momentanea_upi ref="refmomentanea_upi"/>

    <div class="row" style="background:#E9F2F7;">
      <div class="col-sm-12">
        <p class="ma-0 pa-0">
          Para buscar las facturas debe seleccionar la gestion, el mes, el nit, al seleccionar un nit aparecen todas las
          sedes que pertenecen al nit seleccionado, una vez seleccionada la sucursal automaticamente se procede a buscar
          las facturas, puede descargar las facturas en formato excel y en un formato para exportar a facilito.
        </p>
      </div>
      <div class="col-sm-2 col-lg-1">
        <select class="form-control" v-model="gestion">
          <option v-for="(p, ind) in gestiones" :key="ind" :value="p"> {{ p }} </option>
        </select>
        <small>Gestion</small>
      </div>
      <div class="col-sm-2">
        <select class="form-control" v-model="mes">
          <option v-for="(p, ind) in meses" :key="ind" :value="p.id"> {{ p.mes }} </option>
        </select>
        <small>Mes</small>
      </div>
      <div class="col-sm-2">
        <select :disabled="xnitsbysucursal.length == 1" class="form-control" v-model="nit">
          <option v-for="(n, ind) in xnitsbysucursal" :key="ind" :value="n"> {{ n.nro }} </option>
        </select>
        <small>Nit</small>
      </div>
      <div class="col-sm-1">
        <select v-model="estadofact" class="form-control">
          <option value="V"> Validas </option>
          <option value="A"> Anuladas </option>
          <option value="T"> Todas </option>
        </select>
        <small>Estado</small>
      </div>
      <div class="col-sm-5 col-lg-5">
        <p v-if="nit" class="ma-0">
          <small>{{ nit.sucursal.ciudad }} {{ nit.sucursal.direccion }}</small>
        </p>
        <small>Sucursal</small>
      </div>
    </div>

    <div class="table-responsive">
      <input
        v-show="facturas.length"
        type="text"
        style="border:1px solid #1177d1;background:#fefefe"
        v-model="buscar"
        placeholder="Buscar en la tabla..."
      />
      <v-btn v-if="facturas.length>0" class="my-2 ml-2" small color="purple" dark @click="openFacturaPrintMas()" >
        <v-icon>mdi-download</v-icon>  Descargar todos
      </v-btn>
      <table ref="table" class="table table-hover table-condensed" id="midatatable">
        <thead style="background:#196391;">
          <tr class="white--text">
            <th>#</th>
            <th>No. factura</th>
            <th>Nit cliente</th>
            <th>Nit empresa</th>
            <th>Cliente</th>
            <th>Imp. total</th>
            <th>No. Auth</th>
            <th>Estado</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(fact, ind) in facturas" :style="fact.estado == 'A' ? 'background:#FCCDCD' : ''">
            <td>{{ ind + 1 }}</td>
            <td>{{ fact.numero_factura }}</td>
            <td>{{ fact.nit_cliente }}</td>
            <td>{{ fact.nit_empresa }}</td>
            <td>{{ fact.nombre_cliente }}</td>
            <td>{{ fact.importe_total_venta }}</td>
            <td>{{ fact.numero_autorizacion }}</td>
            <td>{{ fact.estado }} </td>
            <td>
              <v-btn class="mt-0 pa-0 mr-8" color="green" icon dark @click="openFacturaPrint(fact.id)" >
                <v-icon>mdi-download</v-icon>`
              </v-btn>
              
              <v-menu left open-on-hover :close-on-content-click="false" offset-x tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mt-0 pa-0" small color="primary" icon dark v-bind="attrs" v-on="on">
                    <v-icon small>mdi-eye</v-icon>`
                  </v-btn>
                </template>

                <div class="bg-primary pa-4" style="background:#196391">
                  <h3 class="text-center white--text mt-0">Detalle de la factura</h3>
                  <hr class="ma-0 blue darken-2" />
                  <v-row class="mb-2">
                    <v-col>
                      <p class="mb-1 mt-0"><b>Especificacion:</b> {{ fact.especificacion }}</p>
                      <p class="mb-1 mt-0"><b>Nro:</b> {{ fact.nro }}</p>
                      <p class="mb-1 mt-0"><b>Fecha:</b> {{ fact.fecha }}</p>
                      <p class="mb-1 mt-0"><b>Fecha limite emision:</b> {{ fact.fecha_limite_emision }}</p>
                      <p class="mb-1 mt-0"><b>Fecha registro:</b> {{ fact.fecha_registro }}</p>
                      <p class="mb-1 mt-0"><b>Hora:</b> {{ fact.hora }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Nro factura:</b> {{ fact.numero_factura }}</p>
                      <p class="mb-1 mt-0"><b>Nro autorizacion:</b> {{ fact.numero_autorizacion }}</p>
                      <p class="mb-1 mt-0"><b>estado:</b> {{ fact.estado }}</p>
                      <p class="mb-1 mt-0"><b>Nit cliente:</b> {{ fact.nit_cliente }}</p>
                      <p class="mb-1 mt-0"><b>Nit empresa:</b> {{ fact.nit_empresa }}</p>
                      <p class="mb-1 mt-0"><b>Razon social:</b> {{ fact.razon_social }}</p>
                      <p class="mb-1 mt-0"><b>Importe total venta:</b> {{ fact.importe_total_venta }}</p>
                      <p class="mb-1 mt-0"><b>Importe iva:</b> {{ fact.importe_iva }}</p>
                      <p class="mb-1 mt-0"><b>Exportaciones:</b> {{ fact.exportaciones }}</p>
                    </v-col>
                    <v-col>
                      <p class="mb-1 mt-0"><b>Ventas tasa cero:</b> {{ fact.ventas_tasa_cero }}</p>
                      <p class="mb-1 mt-0"><b>Subtotal:</b> {{ fact.subtotal }}</p>
                      <p class="mb-1 mt-0"><b>Descuentos iva:</b> {{ fact.descuentos_iva }}</p>
                      <p class="mb-1 mt-0"><b>Importe fiscal:</b> {{ fact.importe_fiscal }}</p>
                      <p class="mb-1 mt-0"><b>Debito fiscal:</b> {{ fact.debito_fiscal }}</p>
                      <p class="mb-1 mt-0"><b>Codigo control:</b> {{ fact.codigo_control }}</p>
                    </v-col>
                  </v-row>
                  <hr class="ma-0 blue darken-2" />
                </div>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="text-center red--text">
        {{ msg }}
      </p>

      <div class="text-center">
        <div style="display: inline-block;" v-show="loading" class="loader"></div>
      </div>

      <FacturasDownload v-if="!$store.state.isonlyread" :facturas="facturas" :datosdescarga="datosdescargas" />
      <print-factura :programa_id="null" ref="refFacturaPrint"></print-factura>
      <PrintFacturaMas :programa_id="null" ref="refFacturaPrintMas"></PrintFacturaMas>
    </div>
  </div>
</template>

<script>
  import FacturasDownload from '@/components/facturastoexcel.vue';
  import { getheadersrest } from '@/components/Utils';
  import gql from 'graphql-tag';
  import PrintFactura from './recibos/PrintFactura.vue';
  import PrintFacturaMas from './recibos/PrintFacturaMas.vue';
  import momentanea_upi from '@/views/upi/factura_upi/momentanea_upi.vue';
  // import axios from "axios";

  export default {
    data() {
      return {
        api_rest: process.env.VUE_APP_API_REST,
        sede: null,
        deltatam: 0,
        msg: '',
        loading: false,
        datosdescargas: {},
        seleccionado: {},
        nits: [],
        //sucursal: { id: null },
        sucursales: [],
        sucursalesbysede: [],
        xnitsbysucursal: [],
        facturas: [],
        nics: [],
        nit: null,
        estadofact: 'V',
        busqueda: {
          fecha_ini: null,
          fecha_fin: null,
        },
        mes: null,
        gestion: null,
        meses: [
          { id: 1, mes: 'Enero' },
          { id: 2, mes: 'Febrero' },
          { id: 3, mes: 'Marzo' },
          { id: 4, mes: 'Abril' },
          { id: 5, mes: 'Mayo' },
          { id: 6, mes: 'Junio' },
          { id: 7, mes: 'Julio' },
          { id: 8, mes: 'Agosto' },
          { id: 9, mes: 'Septiembre' },
          { id: 10, mes: 'Octubre' },
          { id: 11, mes: 'Noviembre' },
          { id: 12, mes: 'Diciembre' },
        ],
        gestiones: [2024,2023, 2022, 2021, 2020 /*, 2019, 2018, 2017*/],
        buscar: '',
      };
    },
    components: { FacturasDownload, PrintFactura,PrintFacturaMas,momentanea_upi },
    watch: {
      buscar: function() {
        this.myFunction1(this.buscar.trim());
      },
      '$store.state.CARGO': function() {
        this.sede = this.$store.state.CARGO.idsede;
        this.facturas = [];
        this.sucursal = {};
        this.nit = null;
        this.getsucursalesall();
        // window.console.log(this.$store.state.CARGO);
      },
      gestion: function() {
        this.evento_filtros();
      },
      mes: function() {
        this.evento_filtros();
      },
      nit: function() {
        this.evento_filtros();
      },
      'sucursal.id': function() {
        this.evento_filtros();
      },
      estadofact: function() {
        this.evento_filtros();
      },
    },
    methods: {
      editar(obj) {
        this.seleccionado = obj;
      },
      modalExitof() {
        //this.getDatos();
      },
      parsesede(s) {
        if (!s) return;
        let guion = s.indexOf('-') + 2;
        let str = s.substring(guion, s.length);
        return str;
      },
      async getDatos(datosserver) {
        const vue = this;
        datosserver.forEach(function(dem) {
          //let xmonto = 0;
          let fs = dem.fecha.split('-');
          /*dem.detalle.forEach((x) => {
                    xmonto += x.monto;
                });*/
          //if (dem.estado == "ANULADA") xmonto = 0;
          dem.importe_total_venta = dem.monto;
          dem.subtotal = dem.monto;
          //dem.debito_fiscal = "" + (xmonto * 0.13).toFixed(2);
          dem.importe_fiscal = dem.monto;
          dem.especificacion = 3;
          dem.importe_iva = 0;
          dem.exportaciones = 0;
          dem.ventas_tasa_cero = 0;
          dem.descuentos_iva = 0;
          //dem.nro = i + vue.deltatam;
          dem.nro = vue.facturas.length + 1;
          dem.fecha_slash = `${fs[2]}/${fs[1]}/${fs[0]}`;
          dem.nombre_cliente = dem.nombre_cliente.toUpperCase();
          /*dem.importe_total_venta = dem.importe_total_venta.replace('.', ',');
          dem.subtotal = dem.subtotal.replace('.', ',');
          dem.debito_fiscal = dem.debito_fiscal.replace('.', ',');
          dem.importe_fiscal = dem.importe_fiscal.replace('.', ',');*/

          if (dem.estado == 'ANULADA') dem.nombre_cliente = '';
          if (dem.estado == 'ANULADA') dem.nit_cliente = 0;
          if (dem.estado == 'ANULADA') dem.importe_total_venta = 0;
          if (dem.estado == 'ANULADA') dem.subtotal = 0;
          if (dem.estado == 'ANULADA') dem.debito_fiscal = 0;
          if (dem.estado == 'ANULADA') dem.importe_fiscal = 0;
          if (dem.estado == 'ANULADA') dem.razon_social = 'ANULADA';

          if (dem.estado == 'ANULADA') dem.estado = 'A';
          else if (dem.estado == 'VALIDA') dem.estado = 'V';

          /*if (dem.estado == "ANULADA") {
                    // ???
                    for (var member in dem) {
                        window.console.log(member);
                        if (member != "estado" && member != "fecha_registro" && member != "codigo_control" && member != "nro" && member != "numero_factura" && member != "nit_cliente" && member != "nit_empresa" && member != "nombre_cliente" && member != "numero_autorizacion") {
                            delete dem[member];
                        }
                    }
                }*/

          vue.facturas.push(dem);
        });
      },
      getfechasrango() {
        let date_inicio = new Date();
        date_inicio.setDate(1);
        date_inicio.setFullYear(this.gestion);
        date_inicio.setMonth(this.mes - 1);

        let date_final = new Date();
        date_final.setDate(1);
        date_final.setMonth(this.mes);
        date_final.setFullYear(this.gestion);
        date_final.setDate(date_final.getDate() - 1);

        let d1 = '01';
        let m1 = date_inicio.getMonth() + 1;
        let y1 = date_inicio.getFullYear();
        let d2 = date_final.getDate();
        let m2 = date_final.getMonth() + 1;
        if (m1 < 10) m1 = '0' + m1;
        if (d2 < 10) d2 = '0' + d2;
        if (m2 < 10) m2 = '0' + m2;
        let fechas = `&fecha_inicio=${d1}/${m1}/${y1}&fecha_fin=${d2}/${m2}/${y1}`;
        return fechas;
      },
      getDatosFacturas() {
        const vue = this;
        vue.loading = true;
        vue.msg = '';
        let myHeaders = getheadersrest();
        let url = `${this.api_rest}/api/pagos/facturas?sucursal_id=${this.nit.sucursal.id}${this.getfechasrango()}`;
        if (this.estadofact != 'T') url += `&estado=${this.estadofact}`;

        let requestOptions = { method: 'GET', headers: myHeaders };
        window.console.log(myHeaders, url);

        fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (!result) result = [];
            //result = vue.correcionfront(result);
            vue.getDatos(result);
            vue.loading = false;
            if (result.length == 0) {
              vue.msg = 'No se han encontrado facturas segun los datos de busqueda ingresados.';
            }
          })
          .catch(() => {
            vue.loading = false;
            // window.console.log(err);
          });
      },
      correcionfront(data) {
        /* CORRECION MOMENTANEA EN FRONT
            SE FILTRA LOS DUPLICADOS
            CUANDO ES ANULADA LOS SIGUIENTES DATOS SON 0:
            importe fiscal, debito fiscal, subtotal, importe total venta*/

        const result = [];
        const vue = this;
        data.forEach((item) => {
          try {
            vue.deltatam = parseInt(data[0].numero_factura);
          } catch (e) {
            window.console.log(e);
          }
          //pushes only unique element
          let d = result.find((x) => x.numero_factura == item.numero_factura);
          if (d && d.estado == 'ANULADA') {
            d.importe_fiscal = '0';
            d.importe_total_venta = '0';
            d.debito_fiscal = '0';
            d.subtotal = '0';
          }
          item.razon_social = item.nombre_cliente + '';

          if (!d) {
            result.push(item);
          }
        });

        window.console.log('FACTURAS:\n', result);
        return result;
        /**/
      },
      myFunction1(filtro) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');

        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },

      evento_filtros() {
        if (!this.nit || !this.nit.id) return;
        if (!this.mes) return;
        if (!this.gestion) return;
        // NIT-idsucursal-anio-mes.xlsx
        let m = this.meses.find((x) => x.id == this.mes).mes;
        let filename = `${this.nit.nro}-${this.nit.sucursal.id}-${this.gestion}-${m}`;
        this.datosdescargas.filename = filename;
        this.facturas = [];
        this.getDatosFacturas();
      },
      getsucursalesall() {
        const vue = this;
        vue.nits = [];
        vue.sucursales = [];
        vue.sucursalesbysede = [];
        vue.loading = true;
        vue.nics = [];
        let qs = gql`
          query {
            getNits {
              id
              nombre
              descripcion
              nro
              estado
            }
            getSucursalesByIdSede(id:${vue.sede}) {
              id
              nit_id
              direccion
              telefono
              ciudad
              numero_sucursal
            }
          }
        `;
        // window.console.log(qs);
        this.$apollo
          .query({
            query: qs,
          })
          .then((data) => {
            // window.console.log('DATA', data.data);
            if (!data.data.getSucursalesByIdSede) data.data.getSucursalesByIdSede = [];
            vue.nits = data.data.getNits;
            vue.sucursales = data.data.getSucursalesByIdSede;
            vue.sucursalesbysede =
              vue.sucursales; /*.filter((x) => {
              return x.sede_id == vue.sede;
            });*/
            vue.sucursalesbysede.forEach((x) => {
              let nitss = vue.nits.filter((n) => {
                return n.id == x.nit_id;
              });
              nitss.forEach((j) => {
                let existe = vue.nics.find((x) => x.id == j.id);
                if (!existe) vue.nics.push(j);
              });
            });
            vue.xnitsbysucursal = [];
            vue.nics.forEach((x) => {
              let pertenece = vue.sucursalesbysede.find((s) => s.nit_id == x.id);
              if (pertenece) {
                x.sucursal = pertenece;
                vue.xnitsbysucursal.push(x);
              }
            });
            // window.console.log('xnits::', vue.xnitsbysucursal, vue.sucursalesbysede);

            vue.loading = false;
            if (vue.nics.length == 1) {
              vue.nit = vue.nics[0];
            }
            if (vue.sucursalesbysede.length == 1) {
              if (!vue.nit.id) vue.nit = vue.nics[0];
              let anio = new Date().getFullYear();
              let mess = new Date().getMonth() + 1;
              vue.gestion = anio;
              vue.mes = mess;
              vue.sucursal = vue.sucursalesbysede[0];
            }
            // window.console.log(vue.sucursales, vue.nits, vue.sucursalesbysede, vue.nics, vue.xnitsbysucursal);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },

      openFacturaPrint(factura_id, recibo) {
        this.$refs.refFacturaPrint.showThisView(factura_id, recibo);
      },
      openFacturaPrintMas() {
        this.$refs.refFacturaPrintMas.showThisView(this.facturas);
      },
      vermomentaneo(){
        // vincent
        // leonardo
        // lucia
        // lilibeth
        const users = this.$store.state.DATA_USER.id==43 || this.$store.state.DATA_USER.id==114112 || this.$store.state.DATA_USER.id==136449 || this.$store.state.DATA_USER.id==137077 || this.$store.state.DATA_USER.id==137075 || this.$store.state.DATA_USER.id==26164
        const sedeid = this.$store.state.CARGO.sede.id== 82
        const isd = users && sedeid
        return isd;
      },
      openUpiMomentaneoFact(){
        this.$refs.refmomentanea_upi.openmodal();
      }
    },
    mounted() {
      this.sede = this.$store.state.CARGO.idsede;
      let anio = new Date().getFullYear();
      let mess = new Date().getMonth() + 1;
      this.gestion = anio;
      this.mes = mess;
      this.getsucursalesall();
    },
  };
</script>
